//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/phobos/actions';
import type { SubmittedForm$Props } from './flowTypes'

class SubmittedForm extends React.Component<SubmittedForm$Props> {
    componentWillUpdate(){
        const { phobos } = this.props;
    
        if (phobos.invoiceSubmitted) {
            this.props.invoiceSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <h3>Invoice Data Extraction</h3>
                </div>
                <div className="row">
                    <div className="alert alert-success" role="alert">
                         Your task has been submitted successfully.
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        phobos: state.phobos
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      invoiceSubmissionCompleted: () => {
         dispatch(actions.invoiceSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectPhobos/SubmittedForm.js